import React, { useEffect } from "react";
import PropTypes from "prop-types";
import FormInput from "../../common/FormInput";
import useGenericGet from "../../../hooks/common/useGenericGet";
import useForm from "../../../hooks/common/useForm";
import Loader from "../../common/Loader";
import { COMMERCIAL_ROAD_USER_API} from "../../../constants/api";

const ParkUserFeesAssessment = ({ tax_id, formId, proceed }) => {
  const { form, updateFormValue } = useForm();
  const { loadData, data: vehicle, loading } = useGenericGet();

  useEffect(() => {
    if (tax_id) {
      loadData({ api: COMMERCIAL_ROAD_USER_API, id: tax_id });
    }
  }, [tax_id]);

  const onSubmit = (event) => {
    event.preventDefault();
    proceed({ amount: vehicle?.amount });
  };

  if (loading) return <Loader />;

  return (
    <form id={formId} onSubmit={onSubmit}>
      <div className="panel panel-primary">
        <div className="panel-heading">
          <div className="panel-title">
            Generate Bill for Park User Fees{" "}
          </div>
        </div>

        <div className="panel-body">
          <div className="row">
            <div className="col-lg-12 col-sm-12">
              <div className="form-group">
                <FormInput
                  label="Amount"
                  value={Number(vehicle?.amount || 0).toLocaleString()}
                  disabled
                  required
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

ParkUserFeesAssessment.propTypes = {
  vehicle: PropTypes.shape({
    amount: PropTypes.number,
  }),
};

export default ParkUserFeesAssessment;
